import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-assessments',
  templateUrl: './assessments.component.html',
  styleUrls: ['./assessments.component.scss']
})
export class AssessmentsComponent implements OnInit {
  showDetails:boolean = false;statusCourse:any='';userLoginData:any=[];assignAllCourses:any=[];assignAllAssessments:any=[];assignLetestCourses:any=[];
  indexTab:any=1;assignLetestCoursesLength:any='';assignLetestCoursesPro:any=[];lastViewStatus:any=0;
  user_id:any='';closeResult: any = '';validationMsg:any='';
  course_id:any='';assessment_id:any=''; request_status:number=1;
  constructor(private modalService: NgbModal,private router: Router,private authUser: UsersService,private spinner: NgxSpinnerService) { 
    if (localStorage.getItem('userLoginData') =='' || localStorage.getItem('userLoginData') == null) {
      this.router.navigateByUrl('/');
    }
    this.userLoginData = JSON.parse(localStorage.getItem('userLoginData') || '[]');
  }
  showDetailsEvent() { this.showDetails = !this.showDetails; }

  open(content: any, data:any) { 
    this.user_id = data.user_id
    this.assessment_id= data.assessment_id;
    this.contactAdministrator(this.user_id,this.assessment_id, this.request_status)
    this.modalService.open(content, { centered: true, size: 'sm' }); 
  }
  open1(content: any) { 
    this.modalService.open(content, { centered: true, size: 'sm', backdrop: 'static', keyboard: false }); 
  }
 
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit(): void {
    /***login user data ***/
    if(this.userLoginData !='' || this.userLoginData != null){
     // this.assignLastViewCours();
      this.assignAssessments(this.statusCourse,this.userLoginData.user_id);
    }
  }
  //3 compt and 2 pending and 1 start blank all
  assignAssessments(status:any,user_id:any){
    this.spinner.show();
    this.assignAllCourses=[];
    this.authUser.assignAssessment(status,user_id).subscribe(
      data=>{
          this.spinner.hide();
          this.assignAllAssessments = data.user_assessment_list;
          let j=0;
          for(let i = 0; i < this.assignAllAssessments.length;i++){
            if(this.assignAllAssessments[i].is_active == 1){
              this.assignAllCourses[j]=this.assignAllAssessments[i];
              j++;
            //  console.log(this.assignAllCourses)
            }
          }
      },error=>{
        this.spinner.hide();
      }
    )
  }
  /*****second convert into hr min and sec */
  secondsToHms(d:any) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    return h+ ' hr ' +m+ ' min'; 
}
  /****get data of last view submodule */
  assignLastViewCours(){
    this.spinner.show();
    this.authUser.assignLastViewCourse(this.userLoginData.user_id).subscribe(
      data=>{
        if(data.status == 401){
            document.getElementById('successMsg')?.click();
            this.spinner.hide();
        }else{
          this.assignLetestCoursesLength = data.data;
          this.lastViewStatus=1;
          this.assignLetestCourses = data.data[0];
          if(data.data.length !=0){
            this.assignLetestCoursesPro = data.data[0].user_course_progress;
          }
          this.spinner.hide();
        }
       
      },error=>{
        this.spinner.hide();
      }
    )
  }
  changeTab(Tab:any){
    if(Tab =='All'){
    this.indexTab = 1;
    this.statusCourse = '';
    this.assignAssessments(this.statusCourse,this.userLoginData.user_id);
    }else if(Tab =='New'){
      this.indexTab = 2;
      this.statusCourse = 1;
    this.assignAssessments(this.statusCourse,this.userLoginData.user_id);
    }else if(Tab =='Ongoing'){
      this.indexTab = 3;
      this.statusCourse = 2;
    this.assignAssessments(this.statusCourse,this.userLoginData.user_id);
    }else if(Tab =='Completed'){
      this.indexTab = 4;
      this.statusCourse = 3;
    this.assignAssessments(this.statusCourse,this.userLoginData.user_id);
    }
  }
  goViewer(modId:any,subModlId:any,courseId:any){
    this.authUser.subModuleStartView(this.userLoginData.user_id,courseId,modId,subModlId).subscribe(
      data=>{
        if(data.status == 401){
            document.getElementById('successMsg')?.click();
            this.spinner.hide();
        }else{
          this.router.navigate(['/viewer'], { queryParams: {modId:modId,subModlId:subModlId,courseId:courseId} });
        }
       
      },error=>{
      }
    )
  }
  contactAdministrator(user_id:number,assessment_id:any, request_status:any){
    this.spinner.show();
    this.authUser.contactAdministratorForAss(user_id,assessment_id, request_status).subscribe(
      data=>{
        if(data.status == 401){
            document.getElementById('successMsg')?.click();
            this.spinner.hide();
        }else{
        this.spinner.hide();
        }
      
      },error=>{
        this.spinner.hide();
      }
    )
  }
  cousreEndDate(endDate:any){
    var date2 = new Date();
    var date1 = new Date(endDate);
    var Time = date2.getTime() - date1.getTime(); 
    var Days = Time / (1000 * 3600 * 24);
    return Days;
  }
  navigationEvent() {
    localStorage.removeItem('userLoginData');
    this.router.navigateByUrl('/'); 
    
  }
  startAssessments(assId:any){
    let assmnt_id=assId
    this.authUser.startAssessment(this.userLoginData.user_id,"",assId).subscribe(
      data=>{
        if(data.status == 401){
          document.getElementById('successMsg')?.click();
          this.spinner.hide();
        }else if(data.status == 200){
          console.log(data,'data')
        this.router.navigate(['/viewer-assessment'], { queryParams: {assId:assmnt_id,AT:0} });
        }
      },error=>{
       // console.log(error);
      }
    )
  }
}